import React, { useState } from 'react'
import { BackDiv } from './BackStyled'

export default function Back({ func, sfx }: any) {
  const [anim, setanim] = useState(false)

  const clickHandler = () => {
    setanim(true)
    setTimeout(() => {
      func(false)
      setanim(false)
    }, 320)
  }
  return (
    <BackDiv
      onClick={() => {
        sfx.play()
        clickHandler()
      }}
      anim={anim}
      data-testid='back'
    >
      BACK
    </BackDiv>
  )
}
